import { render, staticRenderFns } from "./vd-out-stock.vue?vue&type=template&id=0150f073&scoped=true"
import script from "./vd-out-stock.vue?vue&type=script&lang=js"
export * from "./vd-out-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150f073",
  null
  
)

export default component.exports